export const EXCLUDED_ERRORS = [
  /Loading chunk/,
  /Network Error/,
  /Unexpected token '<'/,
  /AndroidJs.onReceiveOtherMedia is not a function/,
  /getErrorPageVideo/,
  /Failed to fetch dynamically imported module/,
  /Request Aborted - Timeout Exceeded/,
  /Load failed/,
  /\[400\] -/,
  /Failed to fetch/,
  /jb/,
  /Unable to preload CSS for/,
  /Cannot read properties of null \(reading 'value'\)/,
  /Cannot read properties of null \(reading 'offsetTop'\)/,
  /Cannot read properties of undefined \(reading 'default'\)/,
  /Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node/,
  /Failed to execute 'insertBefore' on 'Node': The node before which the new node is to be inserted is not a child of this node/,
  /AbortError: The user aborted a request./,
  /Cannot read properties of null \(reading 'getAttribute'\)/,
  /Request failed with status code 500/,
  /element.className.split is not a function/,
  /\[500\] -/,
  /\[401\] -/,
  /\[403\] -/,
  /Method not found/,
  /Cannot read property 'default' of undefined/,
];
